import React, { useState, useEffect, useRef } from "react";

import {
    Button,Dialog,Grid,Icon,Typography, FormHelperText} from "@material-ui/core";

import Scrollbars from "rc-scrollbars";
import CloseIcon from "@material-ui/icons/Close";

import RichTextEditor from "react-rte";
import {
    InputBaseField,
    SelectField
} from "../../../../../components/InputField/InputField";
import {
    Label
    ,DraggableComponent,
} from "../../../../../components/UiElements/UiElements";
import { PostDataAPI } from "../../../../../Services/APIService";
import { withSnackbar } from "../../../../../components/Message/Alert";
import { ActionDialog } from "../../../../../components/ActionDialog/ActionDialog";
import useStyles from "./styles";
import {
    allowedAttachmentsForEmail,
} from "../../../../../../src/components/Common/Extensions";
import PressReleaseHeader from "../../../../../assets/img/common/pressRelease.png";
import PressReleaseFooter from "../../../../../assets/img/common/pressReleaseFooter.png";
import Loader from "../../../../../components/Loader/Loader";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import CallIcon from '@material-ui/icons/Call';
import EmailIcon from '@material-ui/icons/Email';
import LanguageIcon from '@material-ui/icons/Language';

function LetterOfSupportRequest({ dialogOpenClose, handleClose, handleSuccessClose, selectedItem,...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({ distributionListId: 0,title:'',subject:'Letter Of Support' });
    const { showMessage } = props;
    const [distributionList, setDistributionList] = useState([]);
    const [mediaList, setMediaList] = useState([]);
    const addMediaFile = useRef(null);

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [referenceLinkList, setReferenceLinkList] = useState([]);
    let errorList = [];

    const toolbarConfig = {
        display: [
            "INLINE_STYLE_BUTTONS",
            "BLOCK_TYPE_BUTTONS",
            "BLOCK_TYPE_DROPDOWN",
        ],
        INLINE_STYLE_BUTTONS: [
            { label: "Bold", style: "BOLD", className: "custom-css-class" },
            { label: "Italic", style: "ITALIC" },
            { label: "strikethrough", style: "STRIKETHROUGH" },
        ],
        BLOCK_TYPE_BUTTONS: [
            { label: "UL", style: "unordered-list-item" },
            { label: "OL", style: "ordered-list-item" },
            { label: "Blockquote", style: "blockquote" },
        ],
        BLOCK_TYPE_DROPDOWN: [
            { label: "Style", style: "unstyled" },
            { label: "Heading Large", style: "header-one" },
            { label: "Heading Medium", style: "header-two" },
            { label: "Heading Small", style: "header-three" },
        ],
    };

    const [defaultTemplate, setDefaultTemplate] = useState("Select Distribution");

    function isEditorEmpty(_editorValue) {
        let editorDetail = _editorValue.toString('html').replace(regex, '');
        let isEmpty = false;
        if (editorDetail.trim() === ""
            || editorDetail.trim().length === 0
            || editorDetail == "<p><br></p>"
            || !!editorDetail.replace(regex, "") == ""
            || !!editorDetail.replace(regexSpaces, '') == ""
            || editorDetail == "<p></p>") {
            isEmpty = true;
        }
        return isEmpty;
    }

    const regex = /(<([^>]+)>)/gi;
    const regexSpaces = /((&nbsp;))*/gim;

    const MAX_EDITOR_LENGTH = 8000;

    const preGeneratedText = "<p>To Whom It May Concern,</p>"+
        "<p><br>"+
        "It is with great pleasure to write a letter of support for Figgers Foundation in their effort to secure Community Project Funding through an appropriation sponsored by U.S. House Representative Sheila McCormick.</p>" +
"<p><br>"+
        "The proposal, Healthcare Access for EveryBODY, reduces health disparities among children with disabilities and senior veterans - two of the demographic groups least likely to utilize telehealth alternatives. Telehealth use has grown dramatically during the pandemic, with providers seeing 50-to-175 times the number of remote patients than in prior years. According to a nationwide survey conducted by McKinsey, families of children with disabilities and seniors, particularly senior veterans, are the least likely to access telehealth options because of the cost of technology, limited access to internet service, and difficulties in using the technology.</p>" +
    "<p><br>" +
        "The Figgers Foundation request addresses all these critical needs by providing tablet computers with FOCH-compliant telehealth technology that can be configured to an individual's own doctor or to a pool of available physicians within two minutes after the patient initiates the request. The tablets provided have enhanced talk to text capability, inverted screens, audio controls to for navigation, oversized buttons, and durability to withstand dropping.</p>" +
    "<p><br>" +
        "We strongly support this funding request and its focus on increasing access to life-saving healthcare among these at-risk populations by providing telehealth enabled tablets - which are evidence-based interventions to reducing health disparities our community.</p>" +
    "<p><br></p>" +
        "<p>&nbsp;</p>" +
        "<p>All the best,<br>" +
"</p>";
    const [EDITOR_CHAR_LENGTH, setEDITOR_CHAR_LENGTH] = useState(preGeneratedText.length);
    const [editorValue, setEditorValue] = useState(RichTextEditor.createValueFromString(preGeneratedText, 'html'));

    const handleEditorChange = (editorValue) => {
        debugger;
        const editorDetail = editorValue.toString('html').replace(regex, '');

        if (editorDetail && editorDetail.length > (MAX_EDITOR_LENGTH)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEditorMaxValue: true
            }));
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEditorMaxValue: false
            }));
        }
        setEDITOR_CHAR_LENGTH(editorDetail.length);

        if (!isEditorEmpty(editorValue))
            errorMessages.errorMessage = false;
        setEditorValue(editorValue);
    }

    const [errorMessages, setErrorMessages] = useState({});
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false,
        type: "confirm",
        message: "",
    });
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState((prevState) => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback,
        }));
    };
    const getCurrentFormattedDate = () => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = new Date().toLocaleDateString(undefined, options);
        return formattedDate;
    };
    const Validate = (errorList) => {
        
        if (!state.subject) {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorSubject: true,
            }));
            errorList.push(true);
        } else {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorSubject: false,
            }));
        }
        if (!state.title) {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorTitle: true,
            }));
            errorList.push(true);
        } else {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorTitle: false,
            }));
        }

        if (!state.distributionListId || state.distributionListId <= 0) {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorDistributionListId: true,
            }));
            errorList.push(true);
        } else {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorDistributionListId: false,
            }));
        }

        const editorDetail = editorValue.toString('html').replace(regex, '');
        if (isEditorEmpty(editorValue)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorMessage: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorMessage: false
            }));
        }


        if (editorDetail && editorDetail.length > MAX_EDITOR_LENGTH) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEditorMaxValue: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEditorMaxValue: false
            }));
        }

    }
    const addNew = (losType) => {

        Validate(errorList);
        if (errorList.length < 1) {
            var message = 'Please confirm that all content is proofread and valid. Once confirmed this Letter Of Support will be distributed to all agencies in the selected distribution list.';
            if (losType == 'Draft') {
                message = 'Are you sure you want to save this letter of support as draft? No email will be sent to recipients.!';
            }
            showActionDialog(message, "confirm", function () {
                setIsLoading(true);
                var method = "letterofsupport/add";
                
                //const formData = new FormData();
                //for (var key in state) {
                //    if (state[key] && key != "fileToSend" && key != 'lstLinks' && key != 'mediaFiles' && key != 'mediaFileNames'
                //        && key != "photoName"
                //        && key != "encUserID"
                //    )
                //        formData.append(key, state[key]);
                //}
                //formData.append("status", losType);
                //var editorContent = editorValue.toString('html');
                //formData.append("content", editorContent);
                state.title = state.title.trim()
                state.subject = state.subject.trim()
                state.content = editorValue.toString('html');
                state.status = losType;
                state.signalRConnectionId = sessionStorage.getItem('signalRConnectionId');
                PostDataAPI(method, state, true).then((result) => {
                    setIsLoading(false);
                    if (result.success) {
                        if (result.data) {
                            if (result.data.status === "Draft") {

                                handleSuccessClose("Letter of support saved as draft successfully");

                            }
                            else {
                                handleSuccessClose("Letter of support request sent successfully");

                            }
                        }
                        else {
                            showMessage("Error", "Error sending Letter of support request, please contact administrator", "error", 3000);
                        }
                    }
                    else {
                        showMessage("Error", result.message, "error", 3000);

                    }

                })
            });
        }
    }


    const loadDistributionList = () => {
        setIsLoading(true);
        var params = { category: 'LOS' }
        PostDataAPI("fdndistributionlist/getDistributionList", params).then((result) => {

            if (result.success && result.data) {
                // Define your default value
                const defaultValue = {
                    listId: 0,  // Set a unique value for the default item
                    listName: 'Select distribution list', // Label for the default item
                };
                // Concatenate the default value with result.data
                const dataWithDefault = [defaultValue, ...result.data];

                // Transform the data
                const transformedData = dataWithDefault.map((item) => ({
                    value: item.listId,
                    label: item.listName,
                }));
                setDistributionList(transformedData);
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    };

    const loadDefaultTemplate = () => {
        var params = {
            code: "get_letter_of_support_default_data",
            parameters: ['']
        };

        PostDataAPI("ddl/loadItems", params).then((result) => {
            if (result.success && result.data != null && result.data.length > 0) {
                const losSubject = result.data.find(item => item.t1 === 'los_subject');
                const losDescription = result.data.find(item => item.t1 === 'los_description');
                setState(prevState => ({ ...prevState, 'subject': losSubject ? losSubject.t2 : '' }))
                setEDITOR_CHAR_LENGTH(losDescription.length)
                setEditorValue(RichTextEditor.createValueFromString(losDescription.t2, 'html') );

            }
        })
    }

    const loadLetterOfSupport = () => {
        var params = { letterOfSupportId: selectedItem.letterOfSupportId }
        setIsLoading(true);
        PostDataAPI("letterofsupport/get", params).then((result) => {

            if (result.success && result.data) {
                debugger;
                setState(result.data);
                setEDITOR_CHAR_LENGTH(result.data.content?.length)
                setEditorValue(RichTextEditor.createValueFromString(result.data.content, 'html'));
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }

    useEffect(() => {
        loadDistributionList();
        if (selectedItem && selectedItem.letterOfSupportId > 0) {
            loadLetterOfSupport();
        } else {
            loadDefaultTemplate();
        }
       
    }, []);
    const now = new Date();
    // Convert the current date to ISO string format
    const currentDateTime = now.toISOString().slice(0, 16);
    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={DraggableComponent}
            maxWidth="lg"
            {...props}
        >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>New Letter of Support</Typography>

                        <Icon
                            className={classes.closeIcon}
                            onClick={handleClose}
                            color="primary"
                        >
                            <CloseIcon />
                        </Icon>
                    </div>

                    {isLoading ? <Loader></Loader> : ""}
                    <Scrollbars autoHeight autoHeightMax={'70vh'}>
                        <div className={classes.content}>
                            <Grid container spacing={2}>
                                <Grid item sm={6} md={6} lg={6} xl={6}>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Grid row>
                                                <Label title="Subject" size={50} mandatory={true} />
                                                <InputBaseField
                                                    name="subject"
                                                    value={state.subject}
                                                    onChange={handleChange}
                                                    placeholder="Subject"
                                                    type="text"
                                                    MaxLength={100}
                                                />
                                                {errorMessages.errorSubject &&
                                                    (!state.subject) ? (
                                                    <FormHelperText style={{ color: "red" }}>
                                                        Please enter subject
                                                    </FormHelperText>
                                                ) : (
                                                    ""
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Title" size={50} mandatory={true} />
                                                <InputBaseField
                                                    name="title"
                                                    value={state.title}
                                                    onChange={handleChange}
                                                    placeholder="Title"
                                                    type="text"
                                                    MaxLength={100}
                                                />
                                                {errorMessages.errorTitle &&
                                                    (!state.title) ? (
                                                    <FormHelperText style={{ color: "red" }}>
                                                        Please enter title
                                                    </FormHelperText>
                                                ) : (
                                                    ""
                                                )}
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label
                                                    title="Agency Distribution List"
                                                    size={12}
                                                    mandatory={true}
                                                />

                                                <SelectField
                                                    options={distributionList}
                                                    onChange={handleChange}
                                                    value={state.distributionListId}
                                                    name="distributionListId"
                                                    placeholder={"Select Distribution List"}
                                                    defaultValue={defaultTemplate}
                                                    className={classes.selectBaseInput}
                                                ></SelectField>
                                                {errorMessages.errorDistributionListId &&
                                                    (!state.distributionListId ||
                                                        state.distributionListId <= 0) ? (
                                                    <FormHelperText style={{ color: "red" }}>
                                                        Please select agency distribution list
                                                    </FormHelperText>
                                                ) : (
                                                    ""
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2} className={classes.textEditor}>
                                        <Grid item sm={12} md={12} lg={12} xl={12}>
                                            <Grid row>
                                                <Label title="Message" size={12} mandatory={true} />
                                                <RichTextEditor
                                                    name="content"
                                                    value={editorValue}
                                                    onChange={handleEditorChange}
                                                    className={classes.note}
                                                    placeholder="Message goes here..."
                                                    toolbarConfig={toolbarConfig}
                                                ></RichTextEditor>

                                                {errorMessages.errorMessage && !state.Message ? (
                                                    <FormHelperText style={{ color: "red" }}>
                                                        Please enter a message
                                                    </FormHelperText>
                                                ) : (
                                                    ""
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid
                                    item
                                    sm={6}
                                    md={6}
                                    lg={6}
                                    xl={6}
                                //   className={classes.templateGrid}
                                >
                                    <div className={classes.templateContainer}>
                                        <div>
                                            <img width="100%" src={PressReleaseHeader} />
                                        </div>


                                        <Grid container alignItems="center">
                                            <Grid item lg={6} md={6}></Grid>
                                            <Grid item lg={6} md={6} className={"textRight"}>
                                                <h4>{getCurrentFormattedDate()}</h4>
                                            </Grid>
                                        </Grid>

                                        <div className={"tempContent"}>
                                            <h1 className="textCenter">{state.title}</h1>

                                            <Grid container>
                                                <Grid item md={12} lg={12}>
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: editorValue.toString("html"),
                                                        }}
                                                    ></p>
                                                </Grid>
                                            </Grid>


                                        </div>


                                        <div>

                                            <div>
                                                <b>Please click below link to upload Letter of Support</b>
                                            </div>

                                        </div>

                                        <div>


                                            <a href={"https://figgersfoundation.org/"} target="_blank">
                                                FiggersFoundations
                                            </a>


                                        </div>


                                        <div>
                                            <p className={classes.FooterText}>
                                                The Figgers Foundation is a not-for-profit 501 (c) 3 foundation registered with the IRS and the Florida Department of Agriculture, Chapter s. 496.405, Florida Statutes for the purpose of solicitation of contributions.
                                            </p>
                                        </div>
                                        <div>
                                            <img width={"100%"} src={PressReleaseFooter} />
                                        </div>


                                        <Grid container>
                                            <Grid
                                                lg={12}
                                                md={12}
                                                sm={12}
                                            // className={classes.footerGrid}
                                            >

                                                <Grid container className={classes.templateSocial}>
                                                    <Grid item sm={4} lg={4} md={4}>
                                                        <o> <CallIcon /> 1-800-391-2803</o>
                                                    </Grid>

                                                    <Grid item sm={4} lg={4} md={4}>
                                                        <o> <EmailIcon /> Info@FiggersFoundation.org</o>
                                                    </Grid>

                                                    <Grid item sm={4} lg={4} md={4} style={{ textAlign: 'right' }}>
                                                        <o> <LanguageIcon /> FiggersFoundation.org</o>
                                                    </Grid>

                                                </Grid>


                                                <div className={classes.templateFooter}>


                                                    <Grid container>
                                                        <Grid item lg={12} md={12} sm={12}>
                                                            <p> <LocationOnIcon style={{ fontSize: '18px', margin: '0 5px' }} /> 3810 Inverrary Boulevard, Suite 401 Fort Lauderdale, Florida 33319</p>
                                                        </Grid>

                                                        {/* <Grid item lg={12} md={12} sm={12}>
                                                            <div className={classes.footerLogo}>
                                                              
                                                                <a href="https://www.facebook.com/Figgers-Foundation-2265042470489249/">
                                                                    <img src={FaceBookIcon} alt="Facebook Icon" />
                                                                </a>
                                                                <a href="https://instagram.com/figgersfoundation?igshid=fhe096n05fqb">
                                                                    <img src={InstaIcon} alt="Instagram Icon" />
                                                                </a>
                                                             
                                                                <a href="https://twitter.com/Figgershelps">
                                                                    <img src={TwitterIcon} alt="Twitter Icon" />
                                                                </a>
                                                               
                                                                <a href="https://www.linkedin.com/company/the-figgers-foundation/">
                                                                    <img src={linkedInIcon} alt="LinkedIn Icon" />
                                                                </a>
                                                            </div>
                                                            
                                                        </Grid> */}

                                                    </Grid>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>
                                Close
                            </Button>
                            <Button className={classes.changeBtnSaveDraft} onClick={() => { addNew('Draft') }}>
                                Save As Draft
                            </Button>
                            <Button className={classes.changeBtn} onClick={() => { addNew('Sending') }}>
                                Send
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
                onClose={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
            />
        </Dialog>
    );
};

export default withSnackbar(LetterOfSupportRequest);
